import { App } from "./app";
import { GlobalFlags } from "../flags/global_flags";
import { DataCacheObject } from "../data/data_cache_object";

interface InitializeParams {
  flags: GlobalFlags;
  dataCacheObject: DataCacheObject;
}

export function initialize({ flags, dataCacheObject }: InitializeParams) {
  const app = new App({
    flags: flags,
    dataCacheObject: dataCacheObject,
  });

  app.hydrate();
}
